import { Component, Input, OnInit } from '@angular/core';
import { ValdnWidgetsIPModel } from 'src/app/models/widgets-validation/valdn-widgets-ip.model';

@Component({
  selector: '[appValdnWidgetsIP]',
  templateUrl: './valdn-widgets-ip.component.html',
  styleUrls: ['./valdn-widgets-ip.component.scss']
})
export class ValdnWidgetsIPComponent implements OnInit {
  @Input() data: ValdnWidgetsIPModel = new ValdnWidgetsIPModel();

  constructor() { }

  ngOnInit(): void {
  }

}
